<ng-container *ngIf="opportunity.link && opportunity.link.trim() !== ''; else noLink">
  <a [href]="opportunity.link" target="_blank" rel="noopener noreferrer" class="opportunity-card-link" (click)="onCardClick()">
    <div class="opportunity-card">
      <span class="opportunity-label" [ngClass]="opportunity.labelType">{{ opportunity.label }}</span>
      <h4 class="opportunity-title">{{ opportunity.title }}</h4>
      <p class="opportunity-description">{{ opportunity.description }}</p>
      <p class="opportunity-source">{{ opportunity.source }}</p>
    </div>
  </a>
</ng-container>

<ng-template #noLink>
  <div class="opportunity-card opportunity-card-no-link" (click)="onCardClick()">
    <span class="opportunity-label" [ngClass]="opportunity.labelType">{{ opportunity.label }}</span>
    <h4 class="opportunity-title">{{ opportunity.title }}</h4>
    <p class="opportunity-description">{{ opportunity.description }}</p>
    <p class="opportunity-source">{{ opportunity.source }}</p>
  </div>
</ng-template>
